<template>
  <!-- Scroll to top -->
  <transition name="fade">
    <div
      v-show="isScrolled"
      class=" ring-none flex transform cursor-pointer items-center rounded-full border-none bg-indigo-500 p-2 text-white outline-none transition duration-500 hover:scale-110 hover:bg-indigo-600 hover:shadow-sm"
      @click="backToTop"
    >
      <PhCaretUp />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { PhCaretUp } from '@phosphor-icons/vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'

const userScrollPosition = ref(0)

const isScrolled = computed(() => {
  return userScrollPosition.value > 100
})

function updateScrollPosition () {
  userScrollPosition.value = window.scrollY
}

function backToTop () {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', updateScrollPosition)
})

onUnmounted(() => {
  window.removeEventListener('scroll', updateScrollPosition)
})
</script>
